import { RoleFilterKeyString } from 'Attendances/types'

export const ROLE_FIELDS_INITIAL_VALUES: RoleFilterKeyString = {
  id: '',
  name: '',
  category: '',
  status: '',
  role_id: '',
  role_name: '',
  role_category: '',
  role_status: '',
}
